import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  HostListener,
  TemplateRef,
  HostBinding
} from "@angular/core";
import {
  FormBuilder,
  FormArray,
  FormGroup,
  AbstractControl
} from "@angular/forms";
import { FormToolsService } from "../core";

import { ArrayBoxComponent } from "../array-box/array-box.component";

@Component({
  selector: "atn-array-expansion-box",
  templateUrl: "./array-expansion-box.component.html",
  styleUrls: ["./array-expansion-box.component.scss"]
})
export class ArrayExpansionBoxComponent extends ArrayBoxComponent {
  public step: Number = null;
  active: boolean = false;
  @Input() activeField: String = null;
  @Input() titleField: String = null;
  @Input() titleLabel: String = "Elemento";
  @Input() getTitle: Function = (item, i) => {
    let title =
      this.titleField && item.get(this.titleField)
        ? item.get(this.titleField).value
        : null;

    if (!title) {
      title = `${this.titleLabel} ${i + 1}`;
    }

    return title;
  };
  @Input() getActive: Function = (item, i) => {
    let active =
      this.activeField && item.get(this.activeField)
        ? item.get(this.activeField).value
        : null;

    if (active !== null) {
      this.active = active;
    }

    return active;
  };

  setStep(index: number) {
    this.step = index;
  }

  addItem() {
    super.addItem();

    this.setStep(this.formArray.length - 1);
  }

  duplicateItem($event, i: number) {
    super.duplicateItem($event, i);

    this.setStep(i + 1);

    return false;
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms/src/array-expansion-box/array-expansion-box.component.ts